import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { Button, Typography, Box } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const API_URL = process.env.REACT_APP_API_URL;

const ViewsLikesAnalytics = ({ postId }) => {
  const [postData, setPostData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (postId) {
      handleFetchData();
    }
  }, [postId]); // Fetch data when postId changes

  const handleFetchData = () => {
    if (!postId) {
      setError("Post ID is required");
      return;
    }

    setError(""); // Clear previous errors

    axios
      .post(`${API_URL}/post/`, { post_id: postId }) // Send post_id in the request body
      .then((response) => {
        setPostData(response.data);
      })
      .catch((error) => {
        setError("There was an error fetching the post data.");
        console.error(error);
      });
  };

  // Prepare chart data
  const chartData = {
    labels: ["Views", "Likes", "Dislikes", "Bookings"], // Added "Bookings" as a new category
    datasets: [
      {
        label: "Post Metrics",
        data: [
          postData?.views,
          postData?.likes,
          postData?.dislikes,
          postData?.booking_count || 0, // Add the booking count (0 as fallback if not available)
        ],
        backgroundColor: ["#42A5F5", "#66BB6A", "#FF7043", "#FFEB3B"], // Colors for bars
        borderColor: ["#1E88E5", "#388E3C", "#F4511E", "#FBC02D"], // Border colors
        borderWidth: 1,
      },
    ],
  };

  return (
    <Box p={3}>
      {/* Title */}
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem", lg: "2.2rem", xl: "2.5rem" },
          fontWeight: "bold",
          textAlign: "center", // Center the text
          marginTop: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          color: "#333",
        }}
      >
        Post Metrics Bar Chart
      </Typography>

      {error && (
        <Typography color="error" variant="body1" sx={{ textAlign: "center", marginTop: "1rem" }}>
          {error}
        </Typography>
      )}

      {/* Button to fetch data */}
      {!postData && !error && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFetchData}
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem" },
              padding: { xs: "0.5rem 1rem", sm: "0.75rem 1.5rem" },
            }}
          >
            Load Post Data
          </Button>
        </Box>
      )}

      {/* Display Chart */}
      {postData && (
        <Box mt={3} display="flex" justifyContent="center">
          <Box sx={{ width: "100%", maxWidth: "800px" }}>
            <Bar data={chartData} options={{ responsive: true }} />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ViewsLikesAnalytics;
